import React from 'react';
import { motion } from 'framer-motion';
import { X, Upload } from 'lucide-react';
interface UploadProgressProps {
  progress: number;
  fileName: string;
  fileSize: number;
  uploadedSize: number;
  onCancel: () => void;
}
export function UploadProgress({
  progress,
  fileName,
  fileSize,
  uploadedSize,
  onCancel
}: UploadProgressProps) {
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="fixed bottom-8 right-8 z-50 w-96 bg-neutral-950 border border-white/20 rounded-sm p-6 shadow-2xl" data-id="element-198">
      {/* Header */}
      <div className="flex items-start justify-between mb-4" data-id="element-199">
        <div className="flex items-center gap-3" data-id="element-200">
          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center" data-id="element-201">
            <Upload className="w-5 h-5 text-white" data-id="element-202" />
          </div>
          <div data-id="element-203">
            <p className="text-sm font-medium text-white" data-id="element-204">Uploading file</p>
            <p className="text-xs text-white/60 truncate max-w-[200px]" data-id="element-205">
              {fileName}
            </p>
          </div>
        </div>
        <button onClick={onCancel} className="text-white/60 hover:text-white transition-colors" aria-label="Cancel upload" data-id="element-206">
          <X className="w-5 h-5" data-id="element-207" />
        </button>
      </div>

      {/* Progress Bar */}
      <div className="mb-3" data-id="element-208">
        <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-209">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: `${progress}%`
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="h-full bg-white rounded-full" data-id="element-210" />
        </div>
      </div>

      {/* Stats */}
      <div className="flex items-center justify-between text-xs" data-id="element-211">
        <span className="text-white/60" data-id="element-212">
          {formatFileSize(uploadedSize)} / {formatFileSize(fileSize)}
        </span>
        <span className="text-white font-medium" data-id="element-213">{Math.round(progress)}%</span>
      </div>
    </motion.div>;
}